import React, {useEffect, useState} from 'react'
import linkBoxesStyle from "../components/css/linkBoxes.module.scss";
import Box from '../components/bigLinkBoxWCoverImage'

export default function({children, linksData}){
    
    return (
        <div className={linkBoxesStyle.container}>
            {
                linksData.map(link=>{
                    return <div className={linkBoxesStyle.boxes}><Box label={link.name} img={link.image} slug={link.slug} /></div>
                })
            }
        </div>
    )
}